import React from 'react';
import { TypedMemo } from '../../../../common/types';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for the whole AI reel flow; each part uses its own slice of it */
import styles from './PromoteReels.module.scss';
/* eslint-enable css-modules/no-unused-class */

interface ReelSectionProps {
  title: string;
  /** A small tag after the title, for example "Optional". */
  tag?: string;
  hint?: string;
  children: React.ReactNode;
}

/** One section of the AI reel form panel: a head with a title and a hint, then the field. */
const ReelSectionComponent: React.FC<ReelSectionProps> = ({ title, tag, hint, children }) => (
  <section className={styles.sec}>
    <div className={styles.secHead}>
      <h3 className={styles.secTitle}>
        {title}
        {tag !== undefined && <span className={styles.secTag}>{tag}</span>}
      </h3>
      {hint !== undefined && <span className={styles.secHint}>{hint}</span>}
    </div>
    {children}
  </section>
);

export const ReelSection = TypedMemo(ReelSectionComponent);
